import React from 'react'
import TripsTrips from '../subsections/trips/trips.js'
import TripsPrivate from '../subsections/trips/private.js'
import TripsTalks from '../subsections/trips/talks.js'
import TripsWorkshops from '../subsections/trips/workshops.js'
import TripsExhibitions from '../subsections/trips/exhibitions.js'
import Layout from '../layouts/index.js'

const IndexPage = () => (
  <Layout>
    <div>
      <h1 id="tripsandevents">Trips & Events</h1>
      <section id="trips">
        <TripsTrips />
      </section>
      <section id="private">
        <TripsPrivate />
      </section>
      <section id="talks">
        <TripsTalks />
      </section>
      <section id="workshops">
        <TripsWorkshops />
      </section>
      <section id="exhibitions">
        <TripsExhibitions />
      </section>
    </div>
  </Layout>
)

export default IndexPage
